/**
 * Who the contact-list switches may turn on.
 *
 * Search results land with company/title/location from the SERP and without
 * sex or profile analysis. Requiring those two made "activate all" a dead
 * control on every freshly loaded list: the header switch disabled itself
 * and swallowed the click. Blacklist / suspended / deleted stay hard holds.
 * "Already contacted elsewhere" is an icon, not a lock — flipping the switch
 * is the user choosing. The campaign-start guard still holds them back there.
 *
 * Activation is keyed by contactId when the LinkedIn URL is missing
 * (Recruiter / Consumer cards often store the member id without a public
 * /in/ URL). Requiring the URL made every such row ineligible.
 */
export type ActivatableContact = {
  isActive?: boolean;
  isBlacklisted?: boolean;
  isSuspended?: boolean;
  isDeleted?: boolean;
  contactedElsewhere?: boolean;
  linkedInURL?: string;
  contactId?: string;
};

export const isEligibleForActivation = (contact: ActivatableContact): boolean =>
  !contact.isBlacklisted &&
  !contact.isSuspended &&
  !contact.isDeleted &&
  Boolean(contact.contactId?.trim() || contact.linkedInURL?.trim());

export const isViableForHeaderSwitch = (contact: ActivatableContact): boolean =>
  contact.isActive ? true : isEligibleForActivation(contact);
